import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import Customcard from './Customcard';
import proyectosi from "../../images/Content/proyectos.png";

const Proyectosr = () => {
  return (

    <Container>
    <div className='div-proyectos' data-aos="flip-right">
    <h1 className='titulo-servicio'><img className='icono-titulo' src={proyectosi} />Proyectos<img className='icono-titulo' src={proyectosi} /></h1>
            <Row className='row-esp'>
            {/* <Customcard title={"Proyecto Grafica Mega"} linkTo="/Proyectos"/>
            <Customcard title={"Proyecto BacLevelGroup"} linkTo="/Proyectos"/>
            <Customcard title={"Proyecto Aplicacion de pedidos de delivery "} linkTo="/Proyectos"/> */}
            <h3 className='titulo-servicio'>PROXIMAMENTE</h3>
            </Row>
            </div>
    </Container>
  )
}

export default Proyectosr